import Amplify, { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { addToken } from "../../actions/addToken";
import bgImage from "./assets/bgImage.png";
import facebookIcon from "./assets/fbIcon.png";
import frLogo from "./assets/frLogo.png";
import googleIcon from "./assets/googleIcon.png";
import PasswordEyeIcon from "./assets/passwordEyeIcon.png";

import "./global/global.css";

Amplify.configure({
  aws_cognito_region: process.env.REACT_APP_AWS_REGION, // (required) - Region where Amazon Cognito project was created
  aws_user_pools_id: process.env.REACT_APP_COGNITO_POOL_ID, // (optional) -  Amazon Cognito User Pool ID
  aws_user_pools_web_client_id:
    process.env.REACT_APP_COGNITO_POOL_WEB_CLIENT_ID, // (optional) - Amazon Cognito App Client ID (App client secret needs to be disabled)
  aws_mandatory_sign_in: "enable",
});

const SignInForm = (props) => {
  const history = useHistory();

  const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");
  const [signinError, setSigninError] = useState(null);
  const [showNewPasswordModal, setShowNewPasswordModal] = useState(false);
  const [cognitoUser, setCognitoUser] = useState(null);
  const dispatch = props.dispatch;
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPasswordError, setNewPasswordError] = useState(null);
  const [newPasswordLoading, setNewPasswordLoading] = useState(false);

  // toggle function
  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token !== "null" && token !== null) {
      history.push("/dashboard");
    }
  }, []);

  const signIn = async () => {
    try {
      const user = await Auth.signIn(username, password);
      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        setCognitoUser(user);
        setShowNewPasswordModal(true);
        setSigninError(null);
        return;
      }
      dispatch(addToken(user.signInUserSession.idToken.jwtToken));
      setSigninError(null);
      history.push("/dashboard");
    } catch (error) {
      console.log("error signing in", error);
      setSigninError(error);
    }
  };

  const handleSignIn = () => {
    signIn();
  };

  const signInGoogle = () => {
    try {
      window.location.href = process.env.REACT_APP_GOOGLE_LOGIN_URL;
    } catch (error) {
      console.log(error);
    }
  };

  const signInFacebook = () => {
    try {
      window.location.href = process.env.REACT_APP_FACEBOOK_LOGIN_URL;
    } catch (error) {
      console.log(error);
    }
  };

  const toggleShowNewPassword = () => {
    setShowNewPassword((prev) => !prev);
  };

  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleNewPasswordSubmit = async () => {
    setNewPasswordLoading(true);
    setNewPasswordError(null);
    try {
      const completedUser = await Auth.completeNewPassword(
        cognitoUser,
        newPassword
      );
      dispatch(addToken(completedUser.signInUserSession.idToken.jwtToken));
      setShowNewPasswordModal(false);
      setNewPassword("");
      setCognitoUser(null);
      history.push("/dashboard");
    } catch (error) {
      setNewPasswordError(error);
    } finally {
      setNewPasswordLoading(false);
    }
  };

  return (
    <>
      {showNewPasswordModal ? (
        <div className="setPassword-root">
          <div className="loho-bar">
            <img src={frLogo} alt="logo" className="f-logo" />
          </div>
          <div className="cnfrm-password-box">
            <div className="cnf-heading">
              <p>Create New Password</p>
            </div>
            <div className="cnf-sub">
              <p>
                Create a new strong password, that you don’t use for other
                websites.
              </p>
            </div>

            <div className="pwd-box">
              {/* New Password Field */}
              <div
                className="user-input-box pass-box"
                style={{ position: "relative" }}
              >
                <label className="u-label" style={{ color: "black" }}>
                  New Password
                </label>

                <img
                  src={PasswordEyeIcon}
                  alt="password-eye-icon"
                  className="password-eye-icon"
                  onClick={toggleShowNewPassword}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "10px",
                    top: "65%",
                    transform: "translateY(-50%)",
                  }}
                />
                <input
                  type={showNewPassword ? "text" : "password"}
                  placeholder="Enter your new password"
                  className="input-box passsord-width-corrector"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>

              {/* Confirm Password Field */}
              <div
                className="user-input-box pass-box"
                style={{ position: "relative" }}
              >
                <label className="u-label" style={{ color: "black" }}>
                  Re-enter Password
                </label>

                <img
                  src={PasswordEyeIcon}
                  alt="password-eye-icon"
                  className="password-eye-icon"
                  onClick={toggleShowConfirmPassword}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "10px",
                    top: "65%",
                    transform: "translateY(-50%)",
                  }}
                />
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Re-Enter your new password"
                  className="input-box passsord-width-corrector"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              {newPassword &&
                confirmPassword &&
                newPassword !== confirmPassword && (
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      letterSpacing: "-0.4px",
                      textAlign: "left",
                      color: "crimson",
                    }}
                  >
                    Passwords do not match
                  </div>
                )}

              {newPasswordError && (
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    letterSpacing: "-0.4px",
                    textAlign: "left",
                    marginTop: "16px",
                    color: "crimson",
                  }}
                >
                  {newPasswordError.message}
                </div>
              )}

              {/* Pswd Btns */}
              <div className="pswd-btns">
                <div
                  className={`cancel-pwd-btn ${
                    newPasswordLoading ? "disabled" : ""
                  }`}
                  onClick={
                    !newPasswordLoading
                      ? () => {
                          setShowNewPasswordModal(false);
                        }
                      : undefined
                  }
                >
                  <p style={{ margin: 0 }}>CANCEL</p>
                </div>
                <div
                  className={`save-pwd-btn ${
                    newPasswordLoading ||
                    !newPassword ||
                    !confirmPassword ||
                    newPassword !== confirmPassword
                      ? "disabled"
                      : ""
                  }`}
                  onClick={
                    newPasswordLoading ||
                    !newPassword ||
                    !confirmPassword ||
                    newPassword !== confirmPassword
                      ? undefined
                      : handleNewPasswordSubmit
                  }
                >
                  <p style={{ margin: 0 }}>
                    {newPasswordLoading ? "SAVING..." : "SAVE"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="login-page">
          <div
            className="left-side"
            style={{
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <img src={frLogo} alt="frLogo" className="logoImage" />
            <div className="text-container">
              <h1 className="welcome-text" style={{ margin: 0 }}>
                Hello, <span className="welcome-span">welcome!</span>
              </h1>
              <p className="description-text">
                Your <b>trusted partner</b> in simplifying real estate
                transactions.
                <b> Log in</b> to streamline your workflow.
              </p>
            </div>
          </div>
          <div className="right-side">
            <div className="right-content">
              <h2>Create Account</h2>
              <p className="dd">
                <span style={{ color: "black" }}>Sign in</span> to get started
                and explore everything we've got!
              </p>
              <div className="social-icons">
                <div className="usernamePassword-container">
                  <div className="user-input-box">
                    <label className="u-label">Username</label>
                    <input
                      type="text"
                      placeholder="Enter your username"
                      className="input-box"
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                  <div className="user-input-box pass-box">
                    <label className="u-label">Password</label>

                    <img
                      src={PasswordEyeIcon}
                      alt="password-eye-icon"
                      className="password-eye-icon"
                      onClick={toggleShowPassword}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        right: "10px",
                        transform: "translateY(-50%)",
                      }}
                    />
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      className="input-box passsord-width-corrector"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  {signinError && (
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        letterSpacing: "-0.4px",
                        textAlign: "left",
                        marginTop: "16px",
                        color: "crimson",
                      }}
                    >
                      {signinError.message}
                    </div>
                  )}
                  <div className="signBtn" onClick={handleSignIn}>
                    <p className="signIn">SIGN IN</p>
                  </div>
                </div>

                <div className="divider">
                  <div className="line" />
                  <p>or</p>
                  <div className="line" />
                </div>
                <div
                  className="icon-container"
                  onClick={signInGoogle}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={googleIcon}
                    alt="googleIcon"
                    onClick={signInGoogle}
                    className="icon"
                    style={{ cursor: "pointer" }}
                  />
                  <p>Sign in with Google</p>
                </div>

                <div
                  className="icon-container"
                  onClick={signInGoogle}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={facebookIcon}
                    alt="facebookIcon"
                    onClick={signInFacebook}
                    className="icon"
                    style={{ cursor: "pointer" }}
                  />
                  <p>Sign in with Facebook</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect((state) => ({
  dashboardData: state.dashboardData,
  dashboardDataLoading: state.dashboardDataLoading,
}))(SignInForm);
